module.exports = __webpack_public_path__ + "static/img/tablet-header-logo01.3400842e.svg";